/*跨域地址*/
let dev = process.env.dev;
dev = dev + "/c";
const cust = process.env.cust;
const wxlogin = process.env.wxlogin;
const brApi = process.env.brApi;
export default {
  //1V1方案定制微信环境绑定手机号并创建服务单
  cust1V1BindPhone: {
    url: dev + "/dac/order/bind/phone/sv/commit",
    method: "post",
  },
  //查询服务顾问快保工作室信息
  getAgentData: {
    url: brApi + "/c/web/moveres/agent/studio/info",
    method: "get",
  },
  // 客户智能测需记录
  quesRecord: {
    url: dev + "/need/record",
    method: "post",
  },
  // 客户智能测需记录已完成题目数量
  quesRecordNum: {
    url: dev + "/need/record/num",
    method: "put",
  },
  // 数字化获客赋能智能测需提交订单
  dacOrderCommit: {
    url: dev + "/dac/order/needs/commit",
    method: "post",
  },
  // 数字化获客赋能保存渠道浏览记录
  dacOrderVisit: {
    url: dev + "/dac/order/visit",
    method: "post",
  },
  // 星翼社群投放付费h5产品价格人数及头像
  xy1v1People: {
    url: dev + "/dac/order/product/people/url",
    method: "get",
  },
  // 星翼社群投放微信环境绑定手机号根据子渠道创建付费服务单
  xy1v1SubSvCommit: {
    url: dev + "/dac/order/bind/phone/sub/sv/commit",
    method: "post",
  },
  // 查询订单是否支付
  orderPayStatus: {
    url: dev + "/dac/order/pay/status",
    method: "post",
  },
  //保存服务单问卷信息
  saveWecomAnswer: {
    url: dev + "/dac/order/save/question/answer",
    method: "post",
  },
  //判断用户是否填写了问卷
  existAnswer: {
    url: dev + "/dac/order/exist/answer",
    method: "get",
  },
  //对外接口_通过svProductId查询服务商品信息
  dyH5PayProduct: {
    url: cust + "/noauth/h5/pay/sv/product/detail",
    method: "get",
  },
  //获取子渠道投放二维码
  createQrcodeBySubId: {
    url: brApi + "/c/noauth/qrcode/subscribe",
    method: "post",
  },
};



// WEBPACK FOOTER //
// ./src/api/question.js